window.site = (window.site || {});

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.AboutPage = (function AboutPage() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $switch = document.querySelector('.categories-radios');

    if ($switch) {
      const $radios = [].slice.call($switch.querySelectorAll('input[type=radio]'));

      if ($radios) {
        $radios.forEach(($radio) => {
          $radio.addEventListener('change', (e) => {
            const value = $radio.value;
            const $partnersSections = [].slice.call(document.querySelectorAll('.partner-section'));

            $partnersSections.forEach(($partnersSection) => {
              $partnersSection.classList.remove('is-active');
            });

            const $selectedCategory = document.querySelector('.partner-section[data-id="' + value + '"]');
            $selectedCategory.classList.add('is-active');
          });
        });
      }
    }

    const $loadmoreMembers = document.querySelector('#pagination-members');

    if ($loadmoreMembers) {
      $loadmoreMembers.addEventListener("click", loadMoreMembers);
    }

    return true;

  };

  var loadMoreMembers = function(e) {
    let target = e.target || e.srcElement;
    let $hiddenMembers = [].slice.call(document.querySelectorAll('#membres-entrepreneurs .member.is-hidden'));

    if ($hiddenMembers) {
      if ($hiddenMembers.length < 7) {
        target.classList.add('is-hidden');
      } else {
        target.classList.remove('is-hidden');
      }

      $hiddenMembers.forEach(function(element, index) {
        if (index < 6) {
          element.classList.toggle('is-hidden');
        }
      });
    }
  };

  // Expose public methods & properties
  return {
    init: init,
  };

}());
